import { FC, useEffect } from 'react';
import FileUploaderTile from '@views/AdminPage/ImportMedications/FileUploaderTile';
import FileUploader from '@views/AdminPage/ImportMedications/FileUploader/FileUploader';
import { EventType } from '@utils/eventBus';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import useDispatch from '@store/hooks/useDispatch';
import { handleAdminImportSynonymsList } from '@store/features/adminImportMedications/actions';
import {
  adminImportSynonymsListErrorsSelector,
  adminImportSynonymsListLoadingSelector,
} from '@store/features/adminImportMedications/selectors';
import { removeAdminImportSynonymsList } from '@store/features/adminImportMedications/slice';

const ImportSynonymsList: FC = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isLoadingSynonymsList = useSelector(adminImportSynonymsListLoadingSelector);
  const errorsSynonymsList = useSelector(adminImportSynonymsListErrorsSelector);
  const hasErrorsSynonymsList = errorsSynonymsList.length > 0;

  useEffect(() => {
    dispatch(removeAdminImportSynonymsList());
  }, []);

  return (
    <FileUploaderTile title={t('admin.importSynonymsListHeader')}>
      <FileUploader
        className="import-medications__file-uploader"
        importHandler={handleAdminImportSynonymsList}
        errors={errorsSynonymsList}
        eventType={EventType.ADMIN_IMPORT_SYNONYMS_LIST_SUCCESS}
        hasErrors={hasErrorsSynonymsList}
        isLoading={isLoadingSynonymsList}
        successMessage={t('admin.importSynonymsListSuccess')}
      />
    </FileUploaderTile>
  );
};

export default ImportSynonymsList;
